import { customerDocumentTypeMessages } from '@common/intl'
import { CaseDocumentType } from '@gql'
import { defineMessages, type IntlShape } from 'react-intl'

export const caseDocumentTypeMessages = defineMessages({
  closingMediationLetter: {
    defaultMessage: 'Closing mediation letter',
    description: 'case document type title',
  },
  screenshots: {
    defaultMessage: 'Screenshots',
    description: 'case document type title',
  },
  screenshotsFollowUp: {
    defaultMessage: 'Screenshots - Follow up proof',
    description: 'case document type title',
  },
  screenshotsLegalStatement: {
    defaultMessage: 'Screenshots - Legal statement',
    description: 'case document type title',
  },
})

export function translateCaseDocumentType(
  intl: IntlShape,
  type: CaseDocumentType,
  otherType: string | null,
): string {
  switch (type) {
    case CaseDocumentType.CLOSING_MEDIATION_LETTER:
      return intl.formatMessage(caseDocumentTypeMessages.closingMediationLetter)
    case CaseDocumentType.SCREENSHOTS_FOLLOW_UP:
      return intl.formatMessage(caseDocumentTypeMessages.screenshotsFollowUp)

    case CaseDocumentType.SCREENSHOTS_LEGAL_STATEMENT:
      return intl.formatMessage(caseDocumentTypeMessages.screenshotsLegalStatement)
    case CaseDocumentType.SCREENSHOTS:
      return intl.formatMessage(caseDocumentTypeMessages.screenshots)
    case CaseDocumentType.OTHER:
      if (otherType) {
        return intl.formatMessage(customerDocumentTypeMessages.otherWithOtherType, {
          otherType,
        })
      } else {
        return intl.formatMessage(customerDocumentTypeMessages.other)
      }
  }
}
